module.exports = __webpack_public_path__ + "media/images/logos/Stanford-University-a325f052a438a1c725a17091950ffd5d.svg";